<template>
    <div class="container">
        <div class="free-trial-box">
            <!--<h3 class="popup-title">{{$t('hello')}}</h3>-->
            <h3 class="popup-title">Learning <span style="color: red">English</span> through</h3>
            <h6 class="popup-description"><span style="color: #00A3FF">Mathematics</span> and <span style="color: #00A3FF">Science</span></h6>
            <div class="trial-img-title">
                <img src="/images/anomy-img.svg" alt="">
            </div>
            <h3 class="popup-title">{{ $t('choose_grade_1') }}</h3>
            <h3 class="popup-description mb-20">{{ $t('choose_grade_2') }}</h3>

            <div class="grade-select-body">
                <div class="grade-select-list">
                    <div @click="selectGrade(1)" :class="checkGradeSelected(1) ? ['grade-select-item', 'active'] : ['grade-select-item']">1
                    </div>
                    <div @click="selectGrade(2)" :class="checkGradeSelected(2) ? ['grade-select-item', 'active'] : ['grade-select-item']">2
                    </div>
                    <div @click="selectGrade(3)" :class="checkGradeSelected(3) ? ['grade-select-item', 'active'] : ['grade-select-item']">3
                    </div>
                    <div @click="selectGrade(4)" :class="checkGradeSelected(4) ? ['grade-select-item', 'active'] : ['grade-select-item']">4
                    </div>
                    <div @click="selectGrade(5)" :class="checkGradeSelected(5) ? ['grade-select-item', 'active'] : ['grade-select-item']">5
                    </div>
                </div>
            </div>
            <div class="text-center">
                <div class="ito-btn-small let-go mt-20" v-if="grade_selected" :class="grade_selected ? 'active' : ''" style="margin: 15px auto;" @click="onSubmit">
                    {{ $t('let_go_and_try') }}
                </div>
                <div class="ito-btn-small let-go mt-20" v-if="grade_selected == ''" style="margin: 15px auto;">
                    {{ $t('let_go_and_try') }}
                </div>
            </div>
            <!--<div class="free-trial-bottom">-->
            <!--<a href="/login"><h4>{{$t('already_have_an_account')}}</h4></a>-->
            <!--&lt;!&ndash;<a href="/login" class="ito-btn-small active mt-20" style="width: 115px;">{{$t('login')}}</a>&ndash;&gt;-->
            <!--<div class="menu-item select-lang" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#selectLangModal">-->
            <!--<span class="menu-text">{{ $t('language') }}</span>-->
            <!--<img class="flag" :src="locate_info.img_flag" alt="" />-->
            <!--</div>-->
            <!--</div>-->

        </div>


    </div>
</template>

<script>
import { authRegisterAnomynous } from '../../models/auth'
import axios from "axios";
import { mapGetters } from 'vuex'
import { getAvatars, getConfig } from "../../models/profile";
import { getConfigs, getLanguage, soundClick } from "../../utils/utils";

export default {
    name: "RegisterAnomynous",
    data() {
        const configs = getConfigs();
        const locate = getLanguage();
        const localizes = configs.localize || [];

        let locate_info = {};
        localizes.forEach(item => {
            if (item.lang == locate) {
                locate_info = item;
            }
        });
        return {
            error: {
                message: '',
            },
            grade_selected: '',
            locate: getLanguage(),
            locate_info: locate_info,
            configs: configs,
            localizes: localizes,
        };
    },
    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return this.user
        })
    },

    mounted() {
        $('#updateGradeModal').modal('show');
    },
    methods: {
        selectGrade(grade) {
            this.grade_selected = grade;
        },

        checkGradeSelected(grade) {
            return this.grade_selected == grade;
        },
        onSubmit(e) {
            this.resetErrorsValid();

            if (this.error.message != '') {
                return false;
            }
            const grade = this.grade_selected;

            this.login({ grade });

            e.preventDefault();
        },

        resetErrorsValid() {
            this.error = {
                message: '',
            }
        },

        login(user) {
            const that = this;

            that.$store.commit("setLoading", true);

            authRegisterAnomynous(user).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    this.error.message = response.data.msg;

                    return false;
                }

                that.$store.commit('setAuth', true);

                localStorage.removeItem('checkedSubjects');

                localStorage.setItem('access_token', response.data.results.access_token);

                location.href = '/';
            }).catch(({ response }) => {
                this.$store.commit('setAuth', false);
                that.$store.commit("setLoading", false);

                that.error.message = 'An error occurred, please try again later.';
            });
        }
    }
}
</script>

<style scoped>
.form-group {
    position: relative;
}

.ito-input {
    width: 100%;
}

.free-trial-box {
    position: relative;
    width: 658px;
    height: 456px;
    background: #ffffff;
    margin: auto;
    padding: 20px;
    text-align: center;
    box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 4px 0px rgba(231, 231, 231, 0.25);
    border-radius: 8px;
    overflow: hidden;
}

.trial-img-title img {
    width: 110px;
    margin: 15px auto;
}

.free-trial-bottom {
    position: absolute;
    width: 100%;
    margin: auto;
    left: 0;
    bottom: 0;
    padding: 15px;
    background: #3164CC;
}

.free-trial-box a {
    display: block;
    margin: 15px auto;
    cursor: pointer;
    color: #ffffff;
}

.free-trial-box a:hover {
    text-decoration: none;
    color: #ffffff;
}

.free-trial-bottom h4 {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0px;
    color: #ffffff;
}

.select-lang {
    display: block;
    position: absolute;
    bottom: 10px;
    right: 10px;
    padding: 8px;
    background: #ffffff;
    border-radius: 8px;
    cursor: pointer;
}
</style>